import { DronesPanel } from './DronesPanel';
import { InvDetailPanel } from './InvDetailPanel';
import { useInvStore } from './InvStore';
import { UsersPanel } from './UsersPanel';

export function InvOverlay() {
  const view = useInvStore((s) => s.view);
  return (
    <div className="absolute inset-0 bg-(--color-bg) overflow-hidden grid grid-cols-1 lg:grid-cols-12 gap-3 p-3">
      {view === 'users' ? (
        <>
          <section className="rounded-md border border-(--color-border) bg-(--color-surface) overflow-hidden lg:col-span-3 min-h-[280px]">
            <UsersPanel />
          </section>
          <section className="rounded-md border border-(--color-border) bg-(--color-surface) overflow-hidden lg:col-span-9 min-h-[280px]">
            <InvDetailPanel />
          </section>
        </>
      ) : (
        <>
          <section className="rounded-md border border-(--color-border) bg-(--color-surface) overflow-hidden lg:col-span-6 min-h-[280px]">
            <DronesPanel />
          </section>
          <section className="rounded-md border border-(--color-border) bg-(--color-surface) overflow-hidden lg:col-span-6 min-h-[280px]">
            <InvDetailPanel />
          </section>
        </>
      )}
    </div>
  );
}
